import { useCallback } from "react";

import { Box, useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { CloseCircle, HamburgerMenu } from "@solar-icons/react/ssr";
import { useDispatch, useSelector } from "react-redux";

import { mobileNavDrawerId } from "@/nav/navConstants";
import { NavItemIcon } from "@/nav/NavIcons";
import { selectNavOpen, setNavOpen } from "@/nav/navSlice";
import { colorPalette } from "@/themes";

export default function MobileNavButton() {
    const dispatch = useDispatch();
    const theme = useTheme();
    const open = useSelector(selectNavOpen);
    const iconColor =
        theme.palette.mode == "light" ? colorPalette.black : colorPalette.white;

    const handleToggle = useCallback(() => {
        localStorage.setItem("navOpen", !open);
        dispatch(setNavOpen(!open));
    }, [dispatch, open]);

    return (
        <IconButton
            aria-label={open ? "Close navigation menu" : "Open navigation menu"}
            aria-controls={mobileNavDrawerId}
            aria-expanded={open}
            onClick={handleToggle}
            data-testid="mobile-nav-button"
            disableRipple
            sx={{
                width: 17,
                height: 17,
                padding: 0,
                perspective: "72px",
                overflow: "visible",
                "&:hover": {
                    backgroundColor: "transparent",
                },
            }}
        >
            <Box
                component="span"
                sx={{
                    position: "relative",
                    display: "block",
                    width: 17,
                    height: 17,
                    transformStyle: "preserve-3d",
                    transform: open ? "rotateX(90deg)" : "rotateX(0deg)",
                    transition:
                        "transform 360ms cubic-bezier(0.22, 1, 0.36, 1)",
                }}
            >
                <NavItemIcon
                    color={iconColor}
                    icon={HamburgerMenu}
                    size={17}
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: 17,
                        height: 17,
                        backfaceVisibility: "hidden",
                        transform: "translateZ(8.5px)",
                    }}
                />
                <NavItemIcon
                    color={iconColor}
                    icon={CloseCircle}
                    size={17}
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: 17,
                        height: 17,
                        backfaceVisibility: "hidden",
                        transform: "rotateX(-90deg) translateZ(8.5px)",
                    }}
                />
            </Box>
        </IconButton>
    );
}
